export function escapeICS(s) {
  return String(s)
    .replace(/\\/g, "\\\\")
    .replace(/\n/g, "\\n")
    .replace(/,/g, "\\,")
    .replace(/;/g, "\\;");
}
export function daysBetween(a, b) {
  return Math.floor((b.getTime() - a.getTime()) / (24 * 60 * 60 * 1000));
}
export function average(arr) {
  return arr.length ? arr.reduce((s, x) => s + x, 0) / arr.length : 0;
}
export function truncate(s, n) {
  s = String(s || "");
  return s.length > n ? s.slice(0, n - 1) + "…" : s;
}
export function formatNumber(n) {
  return Number(n).toLocaleString();
}
export function formatLocalDateTime(d) {
  return d.toLocaleString([], {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
}
export function formatLocalTime(d) {
  return d.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });
}
export function isoNoPunct(d) {
  return d
    .toISOString()
    .replace(/[-:]/g, "")
    .replace(/\.\d{3}Z$/, "Z");
}
export function dedupe(arr) {
  return Array.from(new Set((arr || []).map((s) => String(s).trim()))).filter(
    Boolean
  );
}
export default escapeICS;
